export default __webpack_public_path__ + "static/media/contact.e12806bf.svg";